import React from 'react'
import {
    Caption,
    H2,
    H3,
    FileUploader,
    Box,
    P,
  } from '@allied-solutions/affinity'

import { InfoBox } from './AppLayout'

  import {
    useStore,
  } from '../hooks'

const UploadRightSide = ({ acceptedTypes, isValid, isOptional }) => {
    const { dispatch, state } = useStore()
    
    return (
        <InfoBox>
            <Box
                display="flex"
                alignItems="baseline"
                justifyContent="space-between"
                pb="6"
            >
                <H2
                className="titleSmall"
                typeStyle="titleSmall"
                fontWeight={900}
                >
                Upload Documents
                </H2>
                {isOptional && (
                    <P typeStyle="bodySmall" textAlign="left" color="gray600">
                        Optional
                    </P>
                )}
            </Box>
            <FileUploader
                files={state?.form?.files || []}
                onChange={files => {
                dispatch({
                    type: 'addToState',
                    payload: { form: { ...state.form, files: files } },
                })
                }}
            >
                <FileUploader.Control
                    id="fileUpload"
                    accept={acceptedTypes}
                    multiple
                />
                {!!state?.form?.files?.length && (
                <>
                    <H3 typeStyle="bodyMedium.bold" textAlign="left" mb={4} mt={10}>
                    Selected files
                    </H3>
                    <FileUploader.FilesList />
                </>
                )}
                {isValid === false && (
                <Caption display="flex" color="error">
                    Please attach at least one file.
                </Caption>
                )}
            </FileUploader>
            </InfoBox>
    )
}

export { UploadRightSide }